
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OccProductSearchAdapter } from '@spartacus/core';
import { ActiveFacetsComponent, FacetService } from '@spartacus/storefront';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { CategoryPageService } from 'src/app/customServices/category-page.service';
import { FormulaBlueService } from 'src/app/services/feature/Formula_blue/formula-blue.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { SteeringGearService } from 'src/app/services/feature/steeringGear/steering-gear.service';

@Component({
  selector: 'app-facet-active-kb',
  templateUrl: './facet-active-kb.component.html',
  styleUrls: ['./facet-active-kb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FacetActiveKbComponent extends ActiveFacetsComponent {
  private categoryFacetSubject = new BehaviorSubject<any>(null);
  oTcategoryData$ = this.categoryFacetSubject.asObservable();
  otherTabFacetAvailable: boolean = false;
  defaultPageSize: number = 12;
  initalPageNum: number = 0;
  facetTabIndex: any = 0;
  categoryCode: any;
  isCategoryPage: boolean;
  SteeringFormData: any;
  formulaFormData: any;
  searchQuery: any;

  private readonly destroy$ = new Subject<void>();
  constructor(facetService: FacetService,
    public productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    public CategoryService: CategoryPageService,
    public activatedRoute: ActivatedRoute,
    private kbSteeringService: SteeringGearService,
    private formulaBlueService: FormulaBlueService,
    private cdr: ChangeDetectorRef
  ) {
    super(facetService);
  }
  ngOnInit() {

    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.searchQuery = data?.['query'];
      if (data?.['categoryCode']) {
        this.facetTabIndex = 6;
        this.isCategoryPage = true;
      }
      else {
        this.productListService.selectedTabIndex.pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.facetTabIndex = data;
        })
        this.isCategoryPage = false;
      }

    })

  }

  FacetClick(e, model?) {
    let queryValue;
    let docQuery;
    let softQuery;
    if ((this.facetTabIndex !== 7) || (this.facetTabIndex !== 8)) {
      queryValue = this.productListService.DecodeQuery(e.removeQuery.query.value);
    }
    if (this.facetTabIndex == 7) {
      docQuery = this.productListService.getCustomDocQuery(e?.removeQuery?.query?.value);
    }
    if (this.facetTabIndex == 8) {
      softQuery = this.productListService.getCustomSoftwareQuery(e?.removeQuery?.query?.value);
    }
    if (this.facetTabIndex == 2) {
      this.productListService.getDocumentDetails(this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          docModel: data,
        });
      })
    } else if (this.facetTabIndex == 3) {
      this.productListService.getSoftwareDetails(this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          softwareModel: data,
        });
      })
    }
    else if (this.facetTabIndex == 1) {
      this.productListService.getCrossRefDetails(this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          crossRefModel: data,
        });
      })
    }
    else if (this.facetTabIndex == 0) {
      const pagination = {
        text: this.searchQuery
      }
      model.pagination = { ...model.pagination, ...pagination };
      this.searchService.search(queryValue, model.pagination).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      })
    }

    else if (this.facetTabIndex == 6) {
      this.CategoryService.getCategoryPageData(model.categoryCode, queryValue, this.initalPageNum, this.defaultPageSize).pipe(takeUntil(this.destroy$)).subscribe();
    }
    else if (this.facetTabIndex == 7) {
      this.productListService.getCustomDocumentDetails(docQuery, this.defaultPageSize, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.seperateDocDetails$.next(x);
      });
    }
    else if (this.facetTabIndex == 8) {
      this.productListService.getCustomSoftwareDetails(softQuery, this.defaultPageSize, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.seperateSoftDetails$.next(x);
      });
    }

    else if (this.facetTabIndex == 9) {
      this.kbSteeringService.SteeringPayLoad$.pipe(takeUntil(this.destroy$)).subscribe(X => {
        this.SteeringFormData = X;
      });
      this.kbSteeringService.submitSteeringData(this.SteeringFormData, this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.SteeringProdDetails$.next(x?.['searchPageData']);
        this.cdr.detectChanges();
      });
    }
    else if (this.facetTabIndex == 10) {
      this.formulaBlueService.formulaBluePayLoad$.pipe(takeUntil(this.destroy$)).subscribe(X => {
        this.formulaFormData = X;
      });
      this.formulaBlueService.submitFormulaData(this.SteeringFormData, this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.FormulaProdDetails$.next(x?.['searchPageData']);
        this.cdr.detectChanges();
      });
    }

  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}




